// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3ydz_","col":"styles_col__8JDIF","fulfillmentStatus":"styles_fulfillmentStatus__2xM38","emailCol":"styles_emailCol__2ONXJ"};